import React from "react";
import "./dashboard.scss";
import CustomNav from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const Dashboard = ({ children }) => {
  return (
    <>
      <CustomNav />
      <div className="dashboardWrapper">
        <div className="dashboardContent">{children}</div>
        <Footer />
      </div>
    </>
  );
};

export default Dashboard;
